import { DEFAULT_LANG } from '../config/Constant';

const SUPPORTED = ['en', 'ori'];
const SITE_ORIGIN = 'https://fup.odisha.gov.in';

export function getDefaultLang() {
  return DEFAULT_LANG === 'ori' ? 'ori' : 'en';
}

export function splitLangPath(pathname = '/') {
  const normalized = pathname.startsWith('/') ? pathname : `/${pathname}`;
  const match = normalized.match(/^\/(en|ori)(?=\/|$)(.*)$/);
  if (!match) return { prefix: null, path: normalized || '/' };

  const rest = match[2] || '/';
  return { prefix: match[1], path: rest.startsWith('/') ? rest : `/${rest}` };
}

/** Plain URLs use DEFAULT_LANG. A /en or /ori prefix is only kept for the other language. */
export function resolveLangFromPath(pathname = window.location.pathname) {
  const { prefix } = splitLangPath(pathname);
  const fallback = getDefaultLang();
  if (prefix && SUPPORTED.includes(prefix) && prefix !== fallback) return prefix;
  return fallback;
}

export function applyLanguageFromUrl() {
  const lang = resolveLangFromPath();
  localStorage.setItem('lang', lang);
  return lang;
}

export function getActiveLang(pathname = window.location.pathname) {
  return resolveLangFromPath(pathname);
}

export function routePathname(pathname = window.location.pathname) {
  const { prefix, path } = splitLangPath(pathname);
  if (prefix && prefix !== getDefaultLang()) return path || '/';
  return pathname;
}

export function withLang(path, lang = getActiveLang()) {
  const [pathname, search = ''] = path.split('?');
  const bare = splitLangPath(pathname).path || '/';
  const next = lang === getDefaultLang() ? bare : `/${lang}${bare === '/' ? '' : bare}`;
  return search ? `${next}?${search}` : next;
}

export function languageUrl(pathname, lang) {
  return `${SITE_ORIGIN}${withLang(pathname, lang)}`;
}

export function routeLocation(location) {
  return { ...location, pathname: routePathname(location.pathname) };
}
